<template>
    <v-app>

        <app-bar />
        <Loading />
        <div>
            <!-- {{ this.gameData }} -->
              <!-- TEST -->
              <!-- <p>{{ this.gameData }}</p> -->
            <iframe class="frame-custom" frameborder="no" scrolling="" style="width: 100%;" allowfullscreen="true" :src="this.gameData.gameurl"></iframe>
        </div>
        <mobile-navigation />
    </v-app>
</template>
<script>
import { mapGetters, mapActions } from 'vuex';
import MobileNavigation from '@/layouts/base/MobileNavigationBar'
import AppBar from '../layouts/base/AppBar.vue';
import CategoryList from "@/components/CategoryList.vue" 
import Loading from "@/components/Loading.vue" 
import MobileNavigationBar from '../layouts/base/MobileNavigationBar.vue';
export default {

    components: {
        MobileNavigation,
        MobileNavigationBar,
        AppBar,
        CategoryList,
        Loading
    },
    computed: {
        ...mapGetters(['getGameCategoryList', 'getGameDataDetail', 'getIsLoadingProgress']),
    },
    data() {
        return {
            gameData: {}
        }
    },
    mounted() {
        this.gameData = this.$route.params.dataGameJoin
    },  
    methods: {
        ...mapActions(['GetGamePage', 'JoinGame']),
        
    }
}
</script>
<style lang="scss">
    .frame-custom {
        height: calc(100vh - 136px) !important;
    }

</style>
